// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2lK8x","index":"styles_index__1Ox86"};